<template>
    <div>
        <v-btn v-if="isAuthed" block tile color="secondary" large depressed class="mt-4 font-weight-bold" :disabled="course.joined" @click="$emit('join-dialog', true)" style="border-radius: 10px">
            <v-icon size="24" left>{{course.pay_type === 'course' ? 'mdi-book-plus-outline' : 'mdi-book-arrow-right-outline'}}</v-icon>

            <span v-if="course.pay_type === 'course'">Enroll Course</span>
            <span v-else>{{course.joined ? 'Joined' : 'Join Now'}}</span>
        </v-btn>
        <v-btn v-else block tile color="secondary" large depressed class="mt-4 font-weight-bold" :to="{name: 'login', query: {course: course.id}}" style="border-radius: 10px">
            <v-icon size="24" left>{{course.pay_type === 'course' ? 'mdi-book-plus-outline' : 'mdi-book-arrow-right-outline'}}</v-icon>
            <span v-if="course.pay_type === 'course'">Enroll Course</span>
            <span v-else>Join Now</span>
        </v-btn>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: ['course'],
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
    }
}
</script>

<style>

</style>